import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJCommonModal from "../../../common/component/modal/FJCommonModal";
import FJLoading from "../../../common/component/FJLoading/FJLoading";

class FJLoadingModalContainer extends Component {

  render() {
    let {
      visible,
    } = this.props;
    return (
      <FJCommonModal visible={visible} >
        <FJLoading />
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowLoadingModal
  }
};

const mapDispatchToProps = function () {
  return {
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJLoadingModalContainer);
